export default __webpack_public_path__ + "static/media/aquisition.11d800c7.jpeg";